/**
 * Authentication API
 * Handles JWT refresh and auth-related operations
 */
import Cookies from 'js-cookie';

export interface RefreshTokenResponse {
  status: string;
  token: string;
  user_context: {
    user_id: number;
    email: string;
    rest_id: number | null;
    restaurant_name: string | null;
    needs_onboarding: boolean;
    subscription_plan: string | null;
  };
}

export const authApi = {
  /**
   * Refresh JWT token with current database state
   * Use this after payment completion to ensure JWT reflects latest subscription status
   *
   * Note: Uses direct fetch() instead of apiClient to avoid double /api prefix
   * Pattern copied from PaymentSuccessSales.tsx (working implementation)
   */
  async refreshContext(): Promise<RefreshTokenResponse> {
    const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://dineai.ai/api';

    const response = await fetch(`${API_BASE_URL}/v1/auth/refresh-context`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${Cookies.get('auth_token')}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Failed with status code ${response.status}`);
    }

    const data = await response.json();

    // Update auth_token cookie with fresh JWT
    // Use same cookie settings as sales portal for consistency
    if (data.token) {
      Cookies.set('auth_token', data.token, {
        expires: 1, // 1 day
        sameSite: 'lax',
        secure: window.location.protocol === 'https:',
        path: '/'
      });
    }

    return data;
  },
};
